import { getRecordList, getMediaUrl, getImageUrl } from '@src/utils/media-data';
import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import { observable } from 'mobx';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { getOmniData, Ids } from '@src/services/omni-api';

class Part2Store extends BaseStore {
  @observable featureData = [];

  @observable activeFeatureIndex = 0;

  featureSwiperStore = new BaseSwiperStore({
    swiperOptions: {
      loop: true,
      spaceBetween: 0,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      pagination: {
        el: '#feature-pagination',
        type: 'bullets',
        clickable: true
      },
      on: {
        slideChangeTransitionEnd: () => {
          // this.onChangeFeatureIndex(this.featureSwiperStore.activeIndex);
        }
      }
    }
  });

  // 获取游戏特色信息
  getFeatureInfo = async () => {
    try {
      const res = await getOmniData(Ids.feature.channel, [{ dataSourceId: Ids.feature.dataSources.ds_id || '' }]);
      const items = getRecordList(res?.[Ids.feature.dataSources.ds_id]?.result?.items);
      console.log('items-------------------', items);
      this.featureData = items.map(item => ({
        title: getImageUrl(item.preview?.length ? item.preview[0]?.name : '').replace(/\.(png|jpg|jpeg|gif|webp)$/i, ''),
        img: getMediaUrl(item.preview)
      }));
    } catch (error) {
      console.log(error);
    }
  };

  use() {
    super.use();
    useMount(() => {
      this.getFeatureInfo();
    });
  }
}

export default Part2Store;
